<template>
<div class="d-flex fullHeight">
    <HelppageSideMenu @set="initialize" class="d-sm-block d-none"/>
    <div class="mainContent mainwindow">
        <div class="p-2">
            <div class="pageTitles">よくある質問</div>
            <div class="cardwindow mt-3 mb-4">
                <div class="accentHelp">
                    <h5 class="font-weight-bold mb-4">ポイントに関して</h5>
<!--                    <div class="border">-->
<!--                        <div class="menu">-->
<!--                            <input id="acd-check1" class="acd-check" type="checkbox">-->
<!--                            <label class="acd-label" for="acd-check1"><a class="acd-label-hover">Q．ポイントカードを持っていれば、Web会員登録に反映していますか？</a></label>-->
<!--                            <div class="acd-content">       -->
<!--                                    <p><br></p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="border">
                        <div class="menu">
                            <input id="acd-check2" class="acd-check" type="checkbox">
                            <label class="acd-label" for="acd-check2"><a class="acd-label-hover">Q．ポイントがついていません。</a></label>
                            <div class="acd-content">
                                    <p>ポイントの付与は翌日となります。<br>
                                    翌朝以降にご確認ください。 <br></p>
                            </div>
                        </div>
                    </div>
                    <div class="border">
                        <div class="menu">
                            <input id="acd-check3" class="acd-check" type="checkbox">
                            <label class="acd-label" for="acd-check3"><a class="acd-label-hover">Q．ROUNDNAVI-WEBでのポイント照会はリアルタイムですか？</a></label>
                            <div class="acd-content">
                                    <p>ポイントの付与は翌日となります。<br>
                                    ポイントの利用はリアルタイムで反映されます。<br></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <HelppageSideMenu @set="initialize" class="d-sm-none"/>
        </div>
    </div>
</div>
</template>


<script>
import HelppageSideMenu from './HelppageSideMenu';
import HelpMenuItem from './components/HelpMenuItem';

export default {
components: {
        HelppageSideMenu,
        HelpMenuItem
    },
    data(){
        return {
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        SigninForm() {
            this.$router.push("/");
        },
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
        }
    }
}
</script>
